import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import format from 'date-fns/format';
import classNames from 'classnames';

import { msg } from 'api';

import { links, linksWithQuery } from '[theme-lib]/links';

const TIME_FORMAT = 'h:mm a';

const getSeasonalDeliveryUrl = linksWithQuery.SEASONAL_DELIVERY({ checkout: 'no' });

// Date as a Date() or in ISO-8601 format will do
const dateOrString = PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]);

export default class DeliveryInformation extends PureComponent {
  static propTypes = {
    deliverySlot: PropTypes.shape({
      startTime: dateOrString.isRequired,
      endTime: dateOrString.isRequired,
      expirationTime: dateOrString,
    }),
    isSeasonalDeliveryAvailable: PropTypes.bool.isRequired,
  };

  render() {
    const { deliverySlot, isSeasonalDeliveryAvailable } = this.props;

    const deliverySection = deliverySlot ? (
      <div className="deliveryInformation">
        <div className="deliveryDate">
          <Link to={links.CHANGE_DELIVERY} className="linkWrap">
            <span className="month">{format(deliverySlot.startTime, 'MMM')}</span>
            <span className="day">{format(deliverySlot.startTime, 'DD')}</span>
          </Link>
        </div>
        <div className={classNames(
          'deliveryDetails', 'pii', { 'deliveryDetails--noExpiration': !deliverySlot.expirationTime }
        )}
        >
          <Link to={links.CHANGE_DELIVERY} className="linkWrap">
            <strong className="linkWrapText--bold">
              {format(deliverySlot.startTime, TIME_FORMAT)} - {format(deliverySlot.endTime, TIME_FORMAT)}
            </strong>
            {deliverySlot.expirationTime && [
              <span key="expInfo" className="deliveryDetails__expInfo">
                Held until {format(deliverySlot.expirationTime, TIME_FORMAT)}
              </span>,
              <span key="expCancel" className="deliveryDetails__expCancel">change</span>,
            ]}
          </Link>
        </div>
      </div>
    ) : (
      <Fragment>
        <Link
          to={links.BOOK_DELIVERY}
          className="bookDelivery button standardBookDelivery"
        >
          Book a delivery
        </Link>
        {isSeasonalDeliveryAvailable && (
          <Link
            className="bookDelivery button bookChristmas"
            to={getSeasonalDeliveryUrl}
            title={msg.delivery.bookChristmasBtn.title}
          >{msg.delivery.bookChristmasBtn.text}
          </Link>
        )}
      </Fragment>
    );

    return (
      <div className="deliveryContainer">
        {deliverySection}
      </div>
    );
  }
}
